import { Component, OnInit } from '@angular/core';
import { I18nService } from '@app/shared/utils/i18n.service';
import { isPlainObjectEqual } from '@app/shared/utils/util';
import { SelectWidget } from 'ngx-schema-form';

@Component({
	selector: 'g-custom-select-widget',
	templateUrl: './custom-select-widget.component.html',
	styleUrls: ['./custom-select-widget.component.scss'],
})
export class CustomSelectWidgetComponent extends SelectWidget implements OnInit {
	items: { label: string; value: unknown }[] = [];
	placeholder = '';
	title = '';

	constructor(private readonly i18n: I18nService) {
		super();
	}

	ngOnInit(): void {
		this.mapItems();
		const locale = this.i18n.getLocaleValue(
			this.schema?.locale as LocaleValue<{ placeholder?: string; title?: string }>,
		);
		this.placeholder = locale?.placeholder;
		this.title = locale?.title ?? this.schema.title;
	}

	selectedLabelFormatter = ({ option }: { option?: unknown } = {}): string => {
		const foundItem = this.items?.find((item) => isPlainObjectEqual(item.value, option));
		if (!foundItem) return this.placeholder;
		return foundItem?.label ?? '???';
	};

	private mapItems() {
		const schemaItems = this.schema?.oneOf ?? [];
		this.items = schemaItems.map((item) => {
			const label = this.i18n.getLocaleValue(item?.locale)?.title ?? item.description;
			const value = item?.enum?.[0] as unknown;
			return { label, value };
		});
	}
}
